export class TrafficNewsFilter {
    constructor(stateFilterSelector, infoTypeFilterSelector, itemsSelector) {
        this.stateFilterSelector = stateFilterSelector;
        this.infoTypeFilterSelector = infoTypeFilterSelector;
        this.itemsSelector = itemsSelector;
        this.stateFilterContainer = document.querySelector(this.stateFilterSelector);
        this.infoTypeFilterContainer = document.querySelector(this.infoTypeFilterSelector);
        this.items = Array.from(document.querySelectorAll(this.itemsSelector));
        if (this.stateFilterContainer && this.infoTypeFilterContainer) {
            this.initListeners();
        }
        const resetLink = document.querySelector(".traffic-news-filter__reset");
        if (resetLink) {
            resetLink.addEventListener("click", (e) => {
                e.preventDefault();
                this.resetFilters();
            });
        }
    }
    initListeners() {
        this.initFilterGroup(this.stateFilterContainer);
        this.initFilterGroup(this.infoTypeFilterContainer);
    }
    initFilterGroup(container) {
        container.addEventListener("click", (event) => {
            const target = event.target;
            if (target.tagName !== "BUTTON")
                return;
            const value = target.getAttribute("data-value");
            if (!value)
                return;
            target.classList.toggle("active");
            this.applyFilter();
        });
    }
    getActiveValues(container) {
        return Array.from(container.querySelectorAll("button.active"))
            .map(btn => btn.getAttribute("data-value") || "");
    }
    showNoResultsMessage(show) {
        let msgEl = document.getElementById("noResultsMessage");
        const filterWrapper = document.querySelector(".traffic-news__wrapper");
        if (!msgEl) {
            msgEl = document.createElement("h3");
            msgEl.id = "noResultsMessage";
            msgEl.textContent = "Derzeit gibt es keine Meldungen für diesen Filter.";
            msgEl.style.fontWeight = "700";
            msgEl.style.padding = "1.5rem";
            if (filterWrapper === null || filterWrapper === void 0 ? void 0 : filterWrapper.parentElement) {
                filterWrapper.parentElement.appendChild(msgEl);
            }
        }
        msgEl.style.display = show ? "block" : "none";
        if (filterWrapper) {
            filterWrapper.style.display = show ? "none" : "";
        }
    }
    applyFilter() {
        const selectedStates = this.getActiveValues(this.stateFilterContainer);
        const selectedInfoTypes = this.getActiveValues(this.infoTypeFilterContainer);
        const filterAllStates = selectedStates.length === 0 || selectedStates.includes("all");
        const filterAllInfoTypes = selectedInfoTypes.length === 0;
        let anyVisible = false;
        this.items.forEach(item => {
            const rowStates = (item.getAttribute("data-state") || "").split(" ").map(s => s.toLowerCase());
            const rowInfoType = (item.getAttribute("data-infotype") || "").toLowerCase();
            const matchesState = filterAllStates || selectedStates.some(val => rowStates.includes(val.toLowerCase()));
            const matchesInfoType = filterAllInfoTypes || selectedInfoTypes.includes(rowInfoType);
            const shouldShow = matchesState && matchesInfoType;
            item.style.display = shouldShow ? "" : "none";
            if (shouldShow)
                anyVisible = true;
        });
        this.showNoResultsMessage(!anyVisible);
    }
    resetFilters() {
        const allButtons = document.querySelectorAll(".filter-btn.active");
        allButtons.forEach(btn => btn.classList.remove("active"));
        this.items.forEach(item => item.style.display = "");
        this.applyFilter();
    }
}
export function initTrafficNewsFilter() {
    new TrafficNewsFilter("#stateFilterButtons", "#infoTypeFilterButtons", ".traffic-news__item");
}
